import { Grid, Typography } from "@mui/material";

import { Resolver, SubmitHandler, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import ProducersComponetModules from "./ProducersComponetModules";
import { Modules, Producer } from "../types";
import TextInput from "../../../main/components/TextInput";
import { useEffect } from "react";

const schema = yup.object({
  amount: yup.number().required("Campo obrigatório"),
  power: yup.number().required("Campo obrigatório"),
});

// Defina o tipo para o Resolver
type MyResolver = Resolver<Modules, yup.InferType<typeof schema>>;

interface EditModulesUsinaProps {
  uG: {
    components?: {
      modules?: {
        amount?: number;
        power?: number;
        producers: Producer[];
      };
    };
  };
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;

  // handleProducersChange: (
  //   objectName: keyof Components,
  //   updatedProducers: Producer[]
  // ) => void;
  updateStateContent: (
    field: string,
    objectName: string,
    value?: number | string | string[] | Producer[]
  ) => void;
}

const EditModuleUsina: React.FC<EditModulesUsinaProps> = ({
  uG,
  isEditing,
  setIsEditing,
  // handleProducersChange,

  updateStateContent,
}) => {
  const {
    handleSubmit,
    control,
    setValue,
    getValues,
    formState: { errors },
    watch,
  } = useForm<Modules>({
    defaultValues: {
      amount: uG?.components?.modules?.amount || 0,
      power: uG?.components?.modules?.power || 0,
      producers: uG?.components?.modules?.producers || [],
    },
    resolver: yupResolver(schema) as MyResolver,
  });

  type ModulesField = keyof Modules;

  // Função para converter o valor de string para número e enviar para o pai
  const handleModulesValueChange = (field: ModulesField, value: string) => {
    const numericValue = value === "" ? undefined : Number(value);
    setValue(field, numericValue);
  };

  //Atualiza os producers
  const handleProducersModules = (updatedProducers: Producer[]) => {
    console.log(
      "M - Dados atualizados de produtores recebidos:",
      updatedProducers
    );

    updateStateContent("producers", "modules", updatedProducers);
  };

  const onSubmit: SubmitHandler<Modules> = async (data) => {
    console.log("onSubmit acionado no filho Modules:", data);

    // Use a função handleInverterValueChange para manipular a mudança de campo
    handleModulesValueChange("amount", String(data.amount));
    handleModulesValueChange("power", String(data.power));

    const producersValue: Producer[] = data.producers || [];

    // array de produtores do estado, tratando 'undefined' como um array vazio
    const existingProducers: Producer[] =
      uG?.components?.modules?.producers || [];

    // Atualize o estado no componente pai, condicionalmente
    if (uG?.components?.modules?.amount !== data.amount) {
      updateStateContent("amount", "modules", data.amount);
    }
    if (uG?.components?.modules?.power !== data.power) {
      updateStateContent("power", "modules", data.power);
    }

    // Converta a quantidade de produtores para um formato aceitável pela função
    const producersValueCount: number = producersValue.length;

    // Atualize o estado no componente pai, condicionalmente
    if (producersValueCount !== existingProducers.length) {
      updateStateContent("producers", "modules", producersValueCount);
    }
    console.log("Formulário submetido com:", data);
  };

  const amount = watch("amount");
  const power = watch("power");

  useEffect(() => {
    console.log(
      "Atualizando amount no componente pai para:",
      getValues("amount")
    );
    updateStateContent("amount", "modules", getValues("amount"));
  }, [amount]);

  useEffect(() => {
    console.log(
      "Atualizando power no componente pai para:",
      getValues("power")
    );
    updateStateContent("power", "modules", getValues("power"));
  }, [power]);

  useEffect(() => {
    const producersArray = (getValues("producers") as Producer[]) || [];

    console.log(
      "Atualizando producers no componente pai para:",
      producersArray
    );

    updateStateContent("producers", "modules", producersArray);
  }, [getValues("producers")]);

  return (
    <Grid
      container
      sx={{
        padding: "20px",
        flexDirection: "row",
        display: "flex",
        backgroundColor: "rgba(217, 217, 217, 0.1)",
        borderRadius: 2,
        marginTop: "8px",
        marginBottom: "8px",
        rowGap: "16px ",
        width: "100%",
      }}
    //   onSubmit={handleSubmit(onSubmit)}
    >
      <Grid item xs={6} textAlign={"start"}>
        <Typography>Módulos</Typography>
      </Grid>

      <Grid container spacing={2}>
        <Grid
          container
          spacing={2}
          sx={{
            padding: "20px",
          }}
          onSubmit={handleSubmit(onSubmit)}
        >
          {isEditing ? (
            <>
              <Grid item xs={12} md={3}>
                <TextInput
                  control={control}
                  fieldName="amount"
                  label={"N° de Módulos"}
                  errors={errors}
                  sx={{
                    width: "100%",
                    marginBottom: "10px",
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextInput
                  control={control}
                  fieldName="power"
                  label={"Potência Instalada"}
                  errors={errors}
                  sx={{
                    width: "100%",
                    marginBottom: "10px",
                  }}
                />
              </Grid>
              {/*  */}
            </>
          ) : (
            <>
              <Grid item xs={12} md={3}>
                <TextInput
                  control={control}
                  fieldName="amount"
                  label={"N° de Módulos"}
                  errors={errors}
                  disabled
                  sx={{
                    width: "100%",
                    marginBottom: "10px",
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextInput
                  control={control}
                  fieldName="power"
                  label={"Potência Instalada"}
                  errors={errors}
                  disabled
                  sx={{
                    width: "100%",
                    marginBottom: "10px",
                  }}
                />
              </Grid>
            </>
          )}
          {/* <Button type="submit" onClick={handleSaveAndExitEditMode}>
            Salvar Dados
          </Button> */}
          <ProducersComponetModules
            producers={uG?.components?.modules?.producers || []}
            isEditing={isEditing}
            // handleProducersChange={(updatedProducers) => {
            //   handleProducersChange("modules", updatedProducers);
            // }}
            handleProducersModules={handleProducersModules}
            setIsEditing={setIsEditing}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EditModuleUsina;
